import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { Auth0LoginErrorHandler } from '../logic';
import { ActiveClosingsPageToggle, ClosingPage, LandingPage, LegalPage, OrderRequestPage, RegisterUser, UnauthedDownloadPage, UnauthedSigningPage, UnauthedOrderRequestPage } from './pages';
import { NotificationPage, UnauthedTaskPage } from './pages';
import { useAuth0 } from '@auth0/auth0-react';
import { AppDrawer, ClosingHeader, LoadingScreen } from './shared';
import { BottomNav } from './shared/BottomNav';
import { usePinTokenState } from './context/pin-state/PinState';
import { NotificationContentOverrideProvider } from './context/notification-content-override/NotificationContentOverrideContext';
import { useOrganization } from './OrganizationProvider';
import { useGetUserConfig } from '../logic/useUserConfig';
import { OrderRequestForm } from './pages/OrderRequestForm';

export const RoutesComponent = function ({ drawerHeight, drawerWidth }: {
  drawerWidth: number;
  drawerHeight: number;
}) {
  const { isAuthenticated, isLoading: authIsLoading } = useAuth0();
  const { pinToken } = usePinTokenState()
  const { auth0TicketId, companyIdOrderIdHash, OrderRequestFeature: orderRequestFeature } = useOrganization()
  const { data: userConfig, isInitialLoading: userConfigIsLoading, isError: userConfigIsError } = useGetUserConfig({ enabled: isAuthenticated })  
  const userRoles = userConfig?.roles || []
  const orderRequestVisibleRoles = orderRequestFeature?.VisibleToRoles || [];
  const shouldDisplayOrderRequest = userRoles.some(role => orderRequestVisibleRoles.includes(role))
  const orderRequestEnabled = orderRequestFeature?.FeatureEnabled;
  const orderRequestEnabledAuthed = (orderRequestFeature?.FeatureEnabled && shouldDisplayOrderRequest) ?? false
  const navigate = useNavigate();

  console.log({authIsLoading, isAuthenticated, userConfigIsLoading, userConfigIsError})

  const isLoading = (authIsLoading || (isAuthenticated && userConfigIsLoading && !userConfigIsError));

  if (isLoading) return <LoadingScreen />

  return (
    <Routes>
      <Route element={<>
        <AppDrawer drawerWidth={drawerWidth} drawerHeight={drawerHeight} orderRequestEnabled={orderRequestEnabledAuthed} />
        <BottomNav drawerWidth={drawerWidth} drawerHeight={drawerHeight} />
      </>}>
        {/* Putting this first, in the case that someone is logged in AND they
            are using a multi signer link. :shrug:
         */}
        <Route path='/signing/:signingHash' element={<UnauthedSigningPage drawerHeight={drawerHeight} />} />
        <Route path='/signing/:signingHash/download' element={<UnauthedDownloadPage drawerHeight={drawerHeight} />} />
        <Route path='/task/:closingId/:section/:id/:userOrderKey' element={pinToken ? <ClosingHeader /> : <UnauthedTaskPage drawerHeight={drawerHeight} />}>
          {/* ClosingHeader has an outlet so it will render the following if there is a pin token. */}
          <Route index element={
            <NotificationContentOverrideProvider>
              <NotificationPage />
            </NotificationContentOverrideProvider>
          } />
        </Route>
        {isAuthenticated ?
          (<>
            {orderRequestEnabledAuthed && (
              <>
                <Route path='/order-requests/*' element={<ClosingHeader titleOverride='Title Order Requests' subtitleOverride='Submit and view your Title Order Requests' />}>
                  <Route path='*' element={<OrderRequestPage />} />
                  <Route path='new' element={<OrderRequestForm onSuccess={()=>{navigate('/order-requests?success=true')}} />} />
                </Route>
              </>
            )}
            <Route path='/closings' element={<ActiveClosingsPageToggle drawerHeight={drawerHeight} />} />

            <Route path='/closings/*' element={<ClosingHeader />}>
              <Route path=':closingId' element={<ClosingPage />} />
              <Route path=':closingId/:section' element={<ClosingPage />} />
              <Route path=':closingId/:section/:id' element={<ClosingPage />} />
            </Route>
            <Route path='/*' element={<Navigate replace to="/closings" />} />
          </>) :
          (
            // if not authed, all routes lead here for register/login/redirection etc.
            <>
              {orderRequestEnabled && <Route path='/order-requests' element={<UnauthedOrderRequestPage />} />}
              <Route path='/*' element={<LandingPage drawerHeight={drawerHeight} />} />
            </>
          )
        }
        {/* Programatic page to navigate the user to the right : */}
        <Route path='/invite/:invitationKey' element={
          <RegisterUser auth0TicketId={auth0TicketId} companyIdOrderIdHash={companyIdOrderIdHash} />
        } />

        {/* Auth0 redirects back to us here.  We render nothing as the
          Auth0Provider detects the code and token query params and reads
          the appState.redirectTo
        */}
        <Route path='/login' element={<Auth0LoginErrorHandler />} />

        <Route path='/legal' element={<LegalPage />} />
      </Route>
    </Routes>
  )
}
